import React from 'react';
import './Image.scss';
import { imageErrors } from '../../../services/subscriberService';
import PropTypes from 'prop-types';
import { selectIcon } from '../selector';
import { CheckValue } from '../../../services/CommonFunction';

const Images = (props) => (
    <img className={props.class || `Image ${props.clas || ''} ${props.disable?'disable':''}`} meta-id={props.meta_id} alt={props.alt} onClick={() => (props.disable?null:props.click())} src={CheckValue(props.src)?props.src:'undefined'} style={props.style} onError={imageErrors.bind(this,props.icon)}  />
)

export default Images;

Images.propTypes = {
    class: PropTypes.string,
    clas: PropTypes.string,
    src: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    meta_id: PropTypes.string.isRequired,
    disable: PropTypes.bool,
    style: PropTypes.object,
    click: PropTypes.func
}

Images.defaultProps = {
    meta_id: 'xyz',
    src: selectIcon('companyPH'),
    alt: 'image',
    icon: 'companyPH',
    style: {},
    click: () => null,
    disable: null
}